import Vue from 'vue';
import { LayoutModule } from '~/store/modules/layout';
import { Component } from 'vue-property-decorator';

@Component({})
export default class DarkTheme extends Vue {
    get isDarkModeActive() {
        return LayoutModule.isDarkModeActive;
    }
    toggleDarkModeActive() {
        LayoutModule.toggleDarkModeActive();
    }
}
